import React, { useEffect, useState } from "react";
import { Container, Button, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../axiosConfig";
import CatalogForm from "./CatalogForm";

export default function CatalogEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [catalog, setCatalog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get(`/catalog/${id}`)
      .then(res => {
        if (alive) {
          setCatalog(res.data);
          setLoading(false);
        }
      })
      .catch(err => {
        alert("Eroare la încărcarea catalogului: " + (err.response?.data?.detail || err.message));
        navigate("/catalog");
      });

    return () => { alive = false; };
  }, [id, navigate]);

  const handleSubmit = async (form) => {
    setSubmitting(true);
    try {
      await api.put(`/catalog/${id}`, form);
      alert("Catalog actualizat cu succes!");
      navigate("/catalog");
    } catch (err) {
      alert("Eroare la actualizarea catalogului: " + (err.response?.data?.detail || err.message));
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" variant="dark" />
        <p className="mt-2 text-muted small">Se încarcă catalogul...</p>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-dark fw-bold m-0">Administrare Catalog: {catalog?.nume_catalog}</h2>
        <Button variant="outline-secondary" onClick={() => navigate("/catalog")}>
          Înapoi la listă
        </Button>
      </div>
      <CatalogForm initialData={catalog} onSubmit={handleSubmit} submitting={submitting} />
    </Container>
  );
}
